import { Paper, Title } from '@mantine/core';

import { YieldMapForm } from '../../../../components/yield-map-form/yield-map-form';
import { useCreateMapPageShared } from '../../../../hooks/use-create-map-page-shared/create-map-page-shared';

import { MAP_TYPES, useProcessYieldMap } from '@fields/data-access';
import { PfMap } from '@map';
import { FullMainHeight } from '@ui';
import { ProcessYieldMapDto } from 'modules/fields/data-access/src/lib/types/dto';

export function CreateYieldMapPage() {
  const { t, navToField, field, fieldId } = useCreateMapPageShared();

  const processMap = useProcessYieldMap();

  const handleSubmit = (values: ProcessYieldMapDto) => {
    processMap.mutate(values, {
      onSuccess: () => {
        navToField(MAP_TYPES.YIELD);
      },
    });
  };

  return (
    <FullMainHeight.Root>
      <FullMainHeight.Header>
        <Paper>
          <Title order={2}>{t('field.yield-map.add-title')}</Title>
        </Paper>
      </FullMainHeight.Header>
      <FullMainHeight.FlexContent>
        <FullMainHeight.Sidebar>
          <Paper h="100%">
            <YieldMapForm
              fieldId={Number(fieldId)}
              loading={processMap.isPending}
              onSubmit={handleSubmit}
            />
          </Paper>
        </FullMainHeight.Sidebar>
        <Paper h="100%" p={0}>
          <PfMap zoomToGeojson={field} />
        </Paper>
      </FullMainHeight.FlexContent>
    </FullMainHeight.Root>
  );
}

export default CreateYieldMapPage;
